import React from 'react';
import { drop } from 'lodash';
import ArticleListBox from './ArticleListBox.jsx';
import FeaturedItem from './FeaturedItem.jsx';
import RowWithTwo from './RowWithTwo.jsx';
const boldbanner = require(`../../../assets/720_405_boldbanner_03.png`);
const TripleNewsBox = ({articles, country}) => (

    <ArticleListBox articles={drop(articles, 9)} >
    <div className="row">
    
        <div className="template-item col-md-12 feed-container feed-container-big">
	      		<a href={`https://boernecancerfonden.dk/bold/?utm_source=TV3&utm_medium=tv1&utm_campaign=bold`}><img className="actual-img loaded" src={boldbanner} alt="Børn Cancer Fonden" /></a><br/>
	    </div>
	  </div>
     	<FeaturedItem contentContainer={articles[0]} country={country} />
        <RowWithTwo articles={[articles[1], articles[2]]} className="featured-news" />
        <FeaturedItem contentContainer={articles[3]} country={country} />
        <RowWithTwo articles={[articles[4], articles[5]]} className="featured-news"/>
        <FeaturedItem contentContainer={articles[6]} country={country} />
        <RowWithTwo articles={[articles[7], articles[8]]} className="featured-news"/>
    </ArticleListBox>
);

export default TripleNewsBox;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/TripleNewsBox_boldbanner.jsx